import * as React from 'react'

import { Text } from '../text/Text'
import { useDataTable } from './DataTableContext'

const defaultCopy = {
  sorted_by: 'Sorted by',
  ascending: 'ascending',
  descending: 'descending',
  separator: '-'
}

export const DataTableMetaData = ({
  copy,
  ...rest
}: React.ComponentProps<typeof Text> & {
  copy?: {
    sorted_by?: string
    ascending?: string
    descending?: string
    separator?: string
  }
  sortLabel?: string
}) => {
  const { getState, columns, getRowModel, rowSelection } = useDataTable()
  const { sorting } = getState()
  const isSorted = sorting.length > 0

  const totalRows = getRowModel()?.rows?.length

  const selectedRows = Object.keys(rowSelection || {}).length

  const copyMerged = { ...defaultCopy, ...copy }

  const getColumnDisplayName = (id: string) => {
    const sortedColumn = columns.find((col) => col.id === id)
    return sortedColumn?.header || id
  }

  const getSortingString = (sorting) => {
    return `${copyMerged.separator} ${
      copyMerged.sorted_by
    } ${getColumnDisplayName(sorting[0].id)} ${
      sorting[0].desc ? copyMerged.descending : copyMerged.ascending
    }`
  }

  return (
    <Text weight="bold" {...rest}>{`${selectedRows || totalRows} ${
      (selectedRows || totalRows) === 1 ? 'item' : 'items'
    } ${selectedRows ? 'selected' : ''} ${
      isSorted ? getSortingString(sorting) : ''
    }`}</Text>
  )
}
